// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"2a70727c","361":"317607c8","511":"98af425a","767":"5bdd4bff"}[chunkId] + ".chunk.js";
};